import { memo } from 'react';
import { RawHtml } from '@divlab/divanui';

import Img from '@UI/Img';
import H2 from '@Components/H2';
import ExplanationsBlock from '@Pages/PageCredit/elements/ExplanationsBlock';
import styles from './PartialDetails.module.css';

import type { FC, HTMLAttributes } from 'react';
import type { FaqData } from '../../typings';

export interface PartialDetailsProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  data: FaqData;
}

const PartialDetails: FC<PartialDetailsProps> = (props) => {
  const { data, className, ...restProps } = props;

  return (
    <div {...restProps} className={className}>
      <H2 title={data.title} className={styles.title} />
      {data.extraInfo && (
        <div className={styles.extraInfoWrapper}>
          <Img
            cnImage={styles.extraInfoIcon}
            className={styles.extraInfoIconContainer}
            src={data.extraInfo.icon}
          />
          <RawHtml className={styles.extraInfoText} html={data.extraInfo.text} />
        </div>
      )}
      <ExplanationsBlock list={data.list} className={styles.questionsList} />
      {data.note && <div className={styles.faqNote}>{data.note}</div>}
      {data.conclusion && <div className={styles.endText}>{data.conclusion}</div>}
    </div>
  );
};

export default memo(PartialDetails);
